import { gql } from '@apollo/client';

const ENDPOINT = {
    GET_BILLING_HISTORY: gql`
        query getBillingHistory($accountId: String!) {
            getBillingHistory(accountId: $accountId) {
                amount
                dueDate
                invoiceDate
                invoiceNumber
            }
        }
    `,

    GET_BALANCE: gql`
        query getBalance($billingAccountId: String!) {
            getBalanceDetails(billingAccountId: $billingAccountId) {
                nonOverdueAmount
                overdueAmount
                lastBillOverdueDate
                date
            }
        }
    `,

    GET_MY_BILL_DETAILS: gql`
        query getMyBillDetails($invoiceId: String!, $billingAccountId: String!) {
            getMyBillDetails(invoiceId: $invoiceId, billingAccountId: $billingAccountId) {
                bills {
                    billAmount {
                        invoiceAmount
                        oneOffAmount
                        recurringAmount
                        usageAmount
                        vatAmount
                    }
                    billPeriod
                    effectiveDate
                    invoiceId
                }
            }
        }
    `,
};

export const getBalanceApi = async ({ graphql, billingAccountId }) => {
    try {
        const data = await graphql.query({
            query: ENDPOINT.GET_BALANCE,
            variables: {
                billingAccountId: billingAccountId,
            },
        });
        return data;
    } catch (error) {
        throw new Error(error);
    }
};

export const getMyBillDetailsApi = async ({ graphql, token, invoiceId }) => {
    try {
        const data = await graphql.query({
            query: ENDPOINT.GET_MY_BILL_DETAILS,
            variables: {
                invoiceId: invoiceId,
                billingAccountId: sessionStorage.getItem('LoggedinUserAccountID'),
            },
        });

        return data;
    } catch (error) {
        throw new Error(error);
    }
};
